import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import { Group, Text, Stage, Layer, Rect, Line} from 'react-konva';

const TimeRuler = ({buffer, zoomedStartTime, convertSecondsToSpace, height, fullDuration}) => { 
    let duration = buffer.duration;
    let lines = [];
    let hop = 15;
    if (duration < 10) {
        hop = 2;
    } else if (duration < 30) {
        hop = 5;
    }  else if (duration > 120) {
        hop = 30;
    }
    for (let i=0; i < zoomedStartTime + duration; i+=hop) {
        if (i - zoomedStartTime < 0) {
            continue;
        }
        let space =  convertSecondsToSpace(i - zoomedStartTime);
        let seconds = i;
        let minutes = Math.floor(seconds / 60);
        let _seconds = seconds % 60;
        if (_seconds < 10) {
            _seconds = "0" + _seconds;
        }
        lines.push((
            <Group>
              <Line
                points={
                    [space,
                     0,
                     space,
                     height]}
                strokeWidth={1}
                stroke={"#2a635b"}
              />
                <Text
                  x={space + 5}
                  y={height - 15}
                  fill="white"
                  fontSize={10}
                  text={minutes + ":" + _seconds}
                />
            </Group>
        ));
    }
    return lines;
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TimeRuler);
